import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ReturnTypeState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-type";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useMemo } from "react";

export const ReturnTypeDetails = memo(function ReturnTypeDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ReturnTypeState>) {
  const returnTypeOptions: BadgeRedoListItem<ReturnTypeEnum>[] = useMemo(
    () => [
      {
        id: "return",
        value: ReturnTypeEnum.RETURN,
        type: "badge" as const,
        badge: { text: "Return", color: "gray" as const },
      },
      {
        id: "claim",
        value: ReturnTypeEnum.CLAIM,
        type: "badge" as const,
        badge: { text: "Claim", color: "gray" as const },
      },
      {
        id: "warranty",
        value: ReturnTypeEnum.WARRANTY,
        type: "badge" as const,
        badge: { text: "Warranty", color: "gray" as const },
      },
      {
        id: "recycle",
        value: ReturnTypeEnum.RECYCLE,
        type: "badge" as const,
        badge: { text: "Recycle", color: "gray" as const },
      },
    ],
    [],
  );

  const selectedOptions = useMemo(
    () =>
      returnTypeOptions.filter((option) =>
        state.returnTypes.includes(option.value),
      ),
    [returnTypeOptions, state.returnTypes],
  );

  return (
    <RedoTagsDropdownInput
      disabled={disabled}
      label="Return Types"
      options={returnTypeOptions}
      placeholder="Select return types..."
      selectedOptions={selectedOptions}
      setSelectedOptions={(items: BadgeRedoListItem<ReturnTypeEnum>[]) => {
        setState({ returnTypes: items.map((item) => item.value) });
      }}
      size="xs"
    />
  );
});
